/** Remove the site's former offline worker and its caches for returning visitors. */
export async function retireServiceWorker(): Promise<void> {
  const cleanup: Promise<unknown>[] = [];

  if ('serviceWorker' in navigator) {
    const workerUrl = new URL(`${import.meta.env.BASE_URL}sw.js`, location.origin).href;
    cleanup.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) =>
          Promise.all(
            registrations
              .filter((registration) =>
                [registration.active, registration.waiting, registration.installing].some(
                  (worker) => worker?.scriptURL === workerUrl,
                ),
              )
              .map((registration) => registration.unregister()),
          ),
        ),
    );
  }

  if ('caches' in window) {
    cleanup.push(
      caches
        .keys()
        .then((names) =>
          Promise.all(
            names.filter((name) => name.startsWith('lyrmo-')).map((name) => caches.delete(name)),
          ),
        ),
    );
  }

  await Promise.allSettled(cleanup);
}
